var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
export var SEARCH_ENDPOINT = "/search?query={0}";
/**
 * SearchApiClient - client for looking for events and leagues BFF endpoints
 * @export
 * @class SearchApiClient
 * @extends {BaseApiClient}
 */
var SearchApiClient = /** @class */ (function (_super) {
    __extends(SearchApiClient, _super);
    function SearchApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Search events and leagues by name from BFF
     * @param {query} string
     * @throws {RequiredError}
     * @memberof SearchApiClient
     */
    SearchApiClient.prototype.search = function (query) {
        var fetchOptions = {
            fetchOptOverride: {
                method: "GET"
            }
        };
        return this.executeRequest(SEARCH_ENDPOINT.format(query), fetchOptions);
    };
    return SearchApiClient;
}(BaseApiClient));
export { SearchApiClient };
//# sourceMappingURL=SearchApiClient.js.map